module.exports = __webpack_public_path__ + "img/footerVip.62b87039.png";